namespace RedBullMOBILE360.Sms {
    export interface WhitelistMemberRow {
        Id?: number;
        WhitelistId?: number;
        Msisdn?: string;
        AddDate?: string;
        AddBy?: number;
        WhitelistWhitelistName?: string;
        WhitelistCreationDate?: string;
        WhitelistLastUpdateDate?: string;
        WhitelistCreatedBy?: number;
    }

    export namespace WhitelistMemberRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'Sms.WhitelistMember';
        export const deletePermission = 'CustomerCare:WhiteList';
        export const insertPermission = 'CustomerCare:WhiteList';
        export const readPermission = 'CustomerCare:WhiteList';
        export const updatePermission = 'CustomerCare:WhiteList';

        export declare const enum Fields {
            Id = "Id",
            WhitelistId = "WhitelistId",
            Msisdn = "Msisdn",
            AddDate = "AddDate",
            AddBy = "AddBy",
            WhitelistWhitelistName = "WhitelistWhitelistName",
            WhitelistCreationDate = "WhitelistCreationDate",
            WhitelistLastUpdateDate = "WhitelistLastUpdateDate",
            WhitelistCreatedBy = "WhitelistCreatedBy"
        }
    }
}
